import React from 'react';
import styles from '@/app/features/auth/pages/phone/styles.module.scss';
import { useTranslation } from 'react-i18next';
import { s } from '@/app/utils/s';
import Space, { spaceSizes } from '@/app/components/Space';
import PhoneInput from '@/app/components/phone_input';
import AuthTitle from '@/app/features/auth/components/auth_title';
import usePhone from "@/app/features/auth/pages/phone/slice";
import Button from "@/app/components/button";
import ErrorLine from "@/app/components/error_line/widget";
import CaptchaPuzzle from "@/app/components/captcha_puzzle";

const PhoneWidget = () => {
    const { t } = useTranslation();
    const {
        phone,
        setPhone,
        loading,
        error,
        phoneContainAllDigits,
        sendOtp,
        showCaptcha,
        onCaptchaSuccess,
        onCaptchaRateLimited,
        onCaptchaClose,
    } = usePhone();

    const privacyPolicy: string = "https://dana-assist.com/privacy-policy";
    const termsOfUse: string = "https://dana-assist.com/terms-of-use/";

    return (
        <div className={styles.main}>
            <AuthTitle title={t(s.auth)} subtitle={t(s.aFourDigitVerificationCode)}/>
            <Space h={spaceSizes.s50}/>
            <PhoneInput className={styles.phoneInput} initialCountryCode="+380" onPhoneChange={setPhone} isError={!error}/>
            <Space h={spaceSizes.s20}/>
            <Button
                isLoading={loading}
                isDisabled={phoneContainAllDigits()}
                onClick={sendOtp}
            >
                {t(s.continue)}
            </Button>
            <Space h={spaceSizes.s14}/>
            <ErrorLine className={styles.errorLine} error={error} />
            <Space h={spaceSizes.s16}/>
            <div className={styles.byContinueYouAgree}>{t(s.byContinueYouAgree)}</div>
            <Space h={spaceSizes.s4}/>
            <div className={styles.linksRow}>
                <a className={styles.link} href={privacyPolicy} target="_blank" rel="noreferrer">{t(s.privacyPolicy)}</a>
                <div>&</div>
                <a className={styles.link} href={termsOfUse} target="_blank" rel="noreferrer">{t(s.privacyPolicy)}</a>
            </div>

            <CaptchaPuzzle
                isOpen={showCaptcha}
                phoneNumber={phone.replace(/ /g, '')}
                onSuccess={onCaptchaSuccess}
                onRateLimited={onCaptchaRateLimited}
                onClose={onCaptchaClose}
            />
        </div>
    );
};

export default PhoneWidget;
